import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizePipe } from './pipes/file-size.pipe';
import { UtcToLocalPipe } from './pipes/utc-to-local.pipe';
import { TranslatedPipe } from './pipes/translated.pipe';
import { TrunkBaseConfigurationService } from './services/trunk-base-configuration/trunk-base-configuration.service';
import { JwtService } from '@core/services/jwt.service';

export function initTrunkBase(trunkConfig: TrunkBaseConfigurationService) {
  return () => trunkConfig.getTrunkBaseConfigurations();
}

export function initJwt(jwtService: JwtService) {
  return () => jwtService.getJwt();
}

@NgModule({
  declarations: [
    FileSizePipe,UtcToLocalPipe,TranslatedPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FileSizePipe,UtcToLocalPipe,TranslatedPipe
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initTrunkBase,
      deps: [TrunkBaseConfigurationService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initJwt,
      deps: [JwtService],
      multi: true
    }
  ]
})
export class CoreModule { }
